export default "__VITE_ASSET__B1ru70Wd__";